<template>
  <div>
      <div class="contentWrap boxed">
        <div class="d2-section">
          <div class="d2-section__header">
              <h2 class="d2-h2">
                  <span :class="icon"> </span>
                  <span class="text_color">{{ $t("all")}} {{getSubCategory($route.params.subcategory, lang_gamebox)}}</span>
              </h2>
          </div>
          <div v-if="isLoad === false">
            <svg class="spinner" viewBox="0 0 50 50">
              <circle
                class="path"
                cx="25"
                cy="25"
                r="20"
                fill="none"
                stroke-width="5"
              ></circle>
            </svg>
          </div>
          <div v-if="isLoad === true">
            <div class="d2-section__content">
              <div class="row itemCollection">
                <div class="col-6 col-md-2 col-lg-2 col-sm-4 d2-appItem d2-appItem--noAnim" v-for="dat in data" :key="dat.key">
                  <a class="d2__inner app" data-toggle="modal" data-target="#contentModal" v-on:click="getDetail(dat.content_id)">
                    <div class="d2-appItem__thumb">
                      <div v-if="dat.content_type === 'application/x-zip-compressed'" class="htmlBadge">
                        <img src="../../assets/mobizone/imgs/html5-badge.png"/>
                      </div>
                      <img class="img_wrp" :src="dat.thumbnail_url" alt="" />
                    </div>
                    <div class="d2-appItem__info">
                      <span v-if="lang_gamebox !== 'english'">
                        <h4 class="d2-h4" v-if="dat[`cont_name_${lang_gamebox}`] !== ''">{{ dat[`cont_name_${lang_gamebox}`] }}</h4>
                        <h4 class="d2-h4" v-else>{{ dat[`cont_name_english`] }}</h4>
                      </span>
                      <span v-else>
                        <h4 class="d2-h4">{{ dat[`cont_name_english`] }}</h4>
                      </span>
                      <div>   
                          <star-rating :inline="true" :star-size="14" :read-only="true" :increment="0.01"  active-color="#FFCF00" :show-rating="false" :border-width="3" border-color="#FFCF00" :rounded-corners="false" inactive-color="transparent" :star-points="[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17]" :rating="Number(dat.rating)"></star-rating>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
import StarRating from 'vue-star-rating';
// Vue.component("star-rating", VueStarRating.default);

export default {
  data() {
    return {
      category: "",
      subcategory: "",
      subcategoryTranslate: "",
      data: {},
      icon: "",
      src: "en",
      dest: "ar",
      dest1: "el",
      isLoad: false
    };
  },
  components:{
    StarRating
  },
  props: ["browse"],
  computed: mapGetters(["lang_gamebox", "country_gamebox", "host_gamebox"]),
  created() {
    //replace '_' with blank space\
    let subcategory = this.$route.params.subcategory;

    subcategory = subcategory.replace("_", " ");
    this.subcategory = subcategory;

    this.getSubContent(this.$route.params.subcategory);
  },
  updated() {
    if (this.$route.params.subcategory != this.subcategory) {
      this.isLoad = false;
      this.data = {};
      this.getSubContent(this.$route.params.subcategory);

      this.subcategory = this.$route.params.subcategory;
    }
  },
  methods: {
    getDetail(id) {
      this.$root.$emit("getDetail", id);
    },
    getSubContent(subcategory) {
      let limit = 0;

      // if (e != undefined) {
      //   limit = parseInt(
      //     e.target.options[e.target.options.selectedIndex].value
      //   );
      // } else {
      //   //default
      //   limit = 100;
      // }

      let live = `http://cook.grabmobi.com`;
      let local = `http://[::1]/PuretechGlobalContentPortal`;
      axios
        .get(
          `${live}/api/contents/newcontents_subcategories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&subcategory=${subcategory}&limit=100&offset=0&domain=${this.host_gamebox}`
        )
        .then(res => {
          let data = res.data.data;

          this.data = data;
          this.isLoad = true;
        })
        .catch(err => {
          // console.log(err);
        });
    },
    getSubCategory(subcategory, lang) {
      let cat_translate = [];
      let hotpick = this.$props.browse.category;
      hotpick.map(item => {
        if (item.title_english.toLowerCase() == subcategory) {
          if (lang != null) {
            cat_translate.push(item[`title_${lang}`]);
          } else {
            cat_translate.push(item[`title_english`]);
          }
        }
      });
      if (cat_translate != "") {
        return cat_translate[0];
      }
    }
  }
};
</script>

<style scoped>
.main_title {
  color: black;
  text-transform: uppercase;
}

.main_part div {
  display: inline-block;
  padding: 0 3px;
  color: black;
}

img.icons {
  background: black;
  height: 32px;
}
</style>


// WEBPACK FOOTER //
// src/components/gamebox/Subcategory.vue